
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import EnhancedSEO from '@/components/EnhancedSEO';
import Breadcrumb from '@/components/Breadcrumb';
import ValorisationHero from '@/components/valorisation/ValorisationHero';
import ValorisationServicesGrid from '@/components/valorisation/ValorisationServicesGrid';
import ValorisationCTA from '@/components/valorisation/ValorisationCTA';

const ValorisationIndex = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Services de Valorisation des Déchets - Groupe Fabre Environnement",
    "description": "Découvrez nos services de valorisation : métaux ferreux et non ferreux, DEEE, papiers cartons. Solutions complètes de recyclage en Occitanie.",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "Service",
          "position": 1,
          "name": "Métaux Ferreux",
          "description": "Recyclage et valorisation de la ferraille, fonte, acier. Rachat au meilleur prix.",
          "url": "https://www.groupefabre-environnement.fr/valorisation/metaux-ferreux"
        },
        {
          "@type": "Service",
          "position": 2,
          "name": "Métaux Non Ferreux",
          "description": "Aluminium, cuivre, zinc, laiton, inox. Collecte et rachat spécialisé.",
          "url": "https://www.groupefabre-environnement.fr/valorisation/metaux-non-ferreux"
        },
        {
          "@type": "Service",
          "position": 3,
          "name": "DEEE",
          "description": "Déchets d'équipements électriques et électroniques. Traitement certifié.",
          "url": "https://www.groupefabre-environnement.fr/valorisation/deee"
        },
        {
          "@type": "Service",
          "position": 4,
          "name": "Papiers Cartons",
          "description": "Collecte et recyclage de tous types de papiers et cartons d'emballage.",
          "url": "https://www.groupefabre-environnement.fr/valorisation/papiers-cartons"
        }
      ]
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": "https://www.groupefabre-environnement.fr/"
        },
        {
          "@type": "ListItem", 
          "position": 2,
          "name": "Valorisation",
          "item": "https://www.groupefabre-environnement.fr/valorisation"
        }
      ]
    }
  };

  const breadcrumbItems = [
    { label: "Accueil", href: "/" },
    { label: "Valorisation", href: "/valorisation", current: true }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <EnhancedSEO
        title="Valorisation des Déchets | Groupe Fabre Environnement"
        description="Services de valorisation et recyclage : métaux ferreux, métaux non ferreux, DEEE, papiers cartons. Solutions professionnelles en Occitanie."
        canonical="/valorisation"
        keywords="valorisation déchets, recyclage métaux, DEEE, papiers cartons, économie circulaire"
        structuredData={structuredData}
      />

      <Navbar />

      <ValorisationHero />

      {/* Breadcrumb */}
      <nav className="bg-gray-50 py-2 md:py-3 border-b border-gray-200">
        <div className="container mx-auto px-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>
      </nav>

      <ValorisationServicesGrid />

      <ValorisationCTA />

      <Footer />
    </div>
  );
};

export default ValorisationIndex;
